import Vue from 'vue'
import { copy } from '@zhenguo/jssdk/clipboard'
import installDirective from '../vue-directive/clipboard'

export default {
  install(app: typeof Vue) {
    installDirective(app)
    app.prototype.$copy = copy
  },
}
